
















































































































































































































































































































import { mapActions, mapGetters } from "vuex";
import { App, General } from "@/utils/constants";
import {
  BOOKMARK_MAX_NAME_SIZE,
  USER_PERMISSIONS as userPermissions
} from "@/utils/enumerate";
import { showErrorMessage } from "@/utils/messageUtility";
import { IBookmark } from "@/store/types/bookmark-types";
import { TemplateRef } from "@/components/types/template";

export default {
  name: "DropdownTagButton",
  props: {
    label: {
      type: String,
      default: General.MARKER
    },
    bookmarkList: {
      type: Array as () => IBookmark[],
      default: () => []
    },
    process: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      App,
      General,
      BOOKMARK_MAX_NAME_SIZE,
      userPermissions,
      isVisible: true,
      isEditable: false,
      bookmarkData: { name: "", color: "", backgroundColor: "" },
      colorList: [
        {
          bgroundColor: "#e67940",
          isSelectedColor: false
        },
        {
          bgroundColor: "#44ad8e",
          isSelectedColor: false
        },
        {
          bgroundColor: "#a8d695",
          isSelectedColor: false
        },
        {
          bgroundColor: "#5cb85c",
          isSelectedColor: false
        },
        {
          bgroundColor: "#69d100",
          isSelectedColor: false
        },
        {
          bgroundColor: "#004e00",
          isSelectedColor: false
        },
        {
          bgroundColor: "#0033cc",
          isSelectedColor: false
        },
        {
          bgroundColor: "#428bca",
          isSelectedColor: false
        },
        {
          bgroundColor: "#34495e",
          isSelectedColor: false
        },
        {
          bgroundColor: "#a295d6",
          isSelectedColor: false
        },
        {
          bgroundColor: "#5843ad",
          isSelectedColor: false
        },
        {
          bgroundColor: "#d10069",
          isSelectedColor: false
        },
        {
          bgroundColor: "#cc0033",
          isSelectedColor: false
        },
        {
          bgroundColor: "#ff0000",
          isSelectedColor: false
        },
        {
          bgroundColor: "#d1d100",
          isSelectedColor: false
        },
        {
          bgroundColor: "#ad8d43",
          isSelectedColor: false
        },
        {
          bgroundColor: "#dcdcdc",
          isSelectedColor: false
        },
        {
          bgroundColor: "#78909c",
          isSelectedColor: false
        },
        {
          bgroundColor: "#90a4Ae",
          isSelectedColor: false
        },
        {
          bgroundColor: "#263238",
          isSelectedColor: false
        },
        {
          bgroundColor: "#000000",
          isSelectedColor: false
        }
      ],
      colorTextList: [
        {
          fontColor: "#ffffff",
          isSelectedColor: false,
          checkIconColor: "is-black"
        },
        {
          fontColor: "#000000",
          isSelectedColor: false,
          checkIconColor: "is-white"
        }
      ],
      selectedTags: [] as string[],
      searchTag: "",
      isLoad: true,
      isLoading: false,
      canShowTooltip: true
    };
  },

  computed: {
    ...mapGetters({
      hasPermission: "hasPermission",
      isContrast: "isContrast"
    }),

    getTags() {
      return this.bookmarkList.filter(tag => {
        return (
          (tag.active || tag.user_id) &&
          tag.name.toLowerCase().includes(this.searchTag.toLowerCase())
        );
      });
    },

    getSelectedTags() {
      const myTags = this.bookmarkList.filter(tag => {
        return this.selectedTags.includes(tag.id);
      });
      const processTags =
        this.process.bookmark?.filter((tag: IBookmark) => {
          return !this.bookmarkList.map(tag => tag.id).includes(tag.id);
        }) || [];
      return [...processTags, ...myTags];
    },

    getBackgroundColorList() {
      return this.colorList.map(colorItem => ({
        ...colorItem,
        isSelectedColor:
          colorItem.bgroundColor == this.bookmarkData.backgroundColor
      }));
    },

    getTextColorList() {
      return this.colorTextList.map(colorItem => ({
        ...colorItem,
        isSelectedColor: colorItem.fontColor == this.bookmarkData.color
      }));
    },

    buttonActionText() {
      if (this.isEditable) return App.ProcessOpeningScreen.EDIT_BOOKMARK;
      if (this.isVisible) return App.ProcessOpeningScreen.SET_BOOKMARK;
      return App.ProcessOpeningScreen.CREATE_BOOKMARK;
    },

    redirectButton() {
      if (this.hasPermission(userPermissions["MANAGE_BOOKMARKS_ADM"]))
        return App.ProcessOpeningScreen.MANAGE_BOOKMARKS_ADM;
      if (this.hasPermission(userPermissions["MANAGE_BOOKMARKS_PART"]))
        return App.ProcessOpeningScreen.MANAGE_BOOKMARKS_PART;
      if (this.hasPermission(userPermissions["MANAGE_BOOKMARKS_CAPACITY"]))
        return App.ProcessOpeningScreen.MANAGE_BOOKMARKS_CAPACITY;
      return undefined;
    }
  },
  watch: {
    selectedTags() {
      !this.isLoad && this.$emit("selectedBookmark", this.getSelectedTags);
    }
  },

  beforeMount() {
    this.selectedTags = this.process.bookmark
      ? this.process.bookmark.map((bookmark: IBookmark) => bookmark.id)
      : [];

    this.$nextTick(() => {
      this.isLoad = false;
    });
  },

  methods: {
    ...mapActions({
      bookmarkRequest: "bookmarkRequest",
      saveBookmarkRequest: "saveBookmarkRequest",
      editBookmarkRequest: "editBookmark"
    }),

    checkCanTramit() {
      if (this.process.can_tramit === false)
        showErrorMessage(General.MESSAGES.WARNING_INTEGRATION_PROCESS);
      return this.process.can_tramit;
    },

    async createBookmark() {
      this.isVisible = false;
      this.isEditable = false;
      this.bookmarkData = {
        name: this.searchTag,
        color: "#ffffff",
        backgroundColor: "#e67940"
      };
      await (this.$refs.bookmarkObserver as TemplateRef).reset();
    },

    async validateData() {
      const isBookmarkValid = await (this.$refs
        .bookmarkObserver as TemplateRef).validate();
      if (!isBookmarkValid) {
        (this as any).snackToast.open({
          message: App.CreateBookmarkScreen.MESSAGES.NAME_EMPTY,
          type: "is-danger",
          duration: 8000
        });
      }
      return isBookmarkValid;
    },

    async editBookmark() {
      const status = await this.editBookmarkRequest(this.bookmarkData);
      if (status) await this.bookmarkRequest({ all: false });
      return status;
    },

    async saveBookmark() {
      if (await this.validateData()) {
        this.isLoading = true;
        const response = this.isEditable
          ? await this.editBookmark()
          : await this.saveBookmarkRequest(this.bookmarkData);

        if (this.isEditable ? response : response.kind) {
          (this as any).snackToast.open({
            message: this.isEditable
              ? App.CreateBookmarkScreen.MESSAGES.BOOKMARK_EDITED
              : General.MESSAGES.BOOKMARKS_SAVED,
            type: "is-success",
            duration: 8000
          });

          if (!this.isEditable) this.selectedTags.push(response.data.id);

          this.searchTag = "";
          this.isVisible = true;
          this.isEditable = false;
        }
        this.isLoading = false;
      }
    },

    remove(id: string) {
      this.selectedTags = this.selectedTags.filter(tagId => tagId !== id);
    },

    setToEdit(tag: IBookmark) {
      this.isVisible = false;
      this.isEditable = true;
      this.bookmarkData = { ...tag };
    },

    changeTooltipStatus(value: boolean) {
      this.canShowTooltip = !value;
    }
  }
};
